import { call, take } from 'redux-saga/effects';

import { GET_VS_MARKERS } from './actions';
import { getMarkers } from 'Services/learnkit';
import { markers as nmMarkers } from 'Lib/normalizers';


function* getVsMarkers() {
  while (true) {
    yield take(GET_VS_MARKERS);

    const { code, markers, message } = yield call(getMarkers);
    yield nmMarkers(markers);
  }
}


export default getVsMarkers;
